import type {
  IOrderDocument,
  IOrderUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOrderDocument,
  updateDocument: updateOrderDocument,
  deleteDocument: deleteOrderDocument,
} = makeDocumentService<IOrderDocument, IOrderUploadDocument>(
  '/api/orderdocuments',
  'orderDocument'
)
